export function isPageVisible(): boolean {
  return !document.hidden;
}
